<template>
  <div class="flow-day-marker flow-current-time mx-auto">
    <div class="p-2 text-center">
      <h4 class="m-0">
        It is {{current_time_formated}}
      </h4>
    </div>
    <div v-if="showConnection" class="flow-block-string position-absolute"></div>
  </div>
</template>

<script>
import moment from '@/moment-gp'

export default {
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true }
  },
  data: () => ({
    item: {},
    interval: '',
    sec_toggle: false,
  }),
  created: function() {
    this.interval = setInterval(() => {
      this.sec_toggle = !this.sec_toggle;
    }, 1000);
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  computed: {
    current_time() {
      return moment.currentTime()
    },
    current_time_formated() {
      let time_str = this.$options.filters.shortTime( this.current_time )
      if ( this.sec_toggle ) {
        return time_str.replace(':', ' ')
      }
      return time_str;
    }
  },
}
</script>

<style>
.flow-current-time {
  font-family: monospace;
}
.flow-current-time > div {
  background: #e2e2e2;
}
</style>
